// extracted by mini-css-extract-plugin
module.exports = {"winDay":"DataCell_winDay__MVaw2","today":"DataCell_today__ovW7o","day":"DataCell_day__4r8z5","selected":"DataCell_selected__Fxik6","disabledDay":"DataCell_disabledDay__tULnO"};